enum excelSourceType {
    defaultValue,
    userValue,
    columnIndex,
    columnHeader,
}

export default excelSourceType;
